import React, { useEffect, useState } from 'react';
import { GeoJSON, MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const WorldMap = ({ onContinentClick }) => {
    const [geoData, setGeoData] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        setIsFetching(true);
        fetch('/data/continents.json')
            .then((res) => res.json())
            .then((data) => {
                data.features = data.features.filter((feature) => feature.geometry);
                data.features = data.features.map((feature) => {
                    feature.properties.continentName =
                        feature.properties.CONTINENT || feature.properties.continent || 'Unknown';
                    return feature;
                });

                setGeoData(data);
                setIsFetching(false);
            })
            .catch((err) => {
                console.error('Error fetching continents geoJSON', err);
                setIsFetching(false);
            });
    }, []);

    const onEachFeature = (feature, layer) => {
        if (!feature.properties || !feature.properties.continentName) return;
        layer.bindPopup(feature.properties.continentName);
        layer.on('click', () => {
            onContinentClick(feature.properties.continentName);
        });
    };

    return (
        <MapContainer
            center={[54.526, 15.2551]}
            zoom={1}
            minZoom={2}
            maxZoom={3}
            style={{ height: '100%', width: '100%' }}
            maxBounds={[
                [-85.05112878, -180],
                [85.05112878, 180]
            ]}
            maxBoundsViscosity={1.0}
            worldCopyJump={false}
            zoomControl={false}
        >
            <TileLayer
                attribution='&copy; OpenStreetMap contributors'
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                maxZoom={19}
                noWrap={true}
            />
            <ZoomControl position='topright' />
            {geoData && (
                <>
                    <GeoJSON
                        data={geoData}
                        onEachFeature={onEachFeature}
                        style={{
                            color: '#607D8B',
                            weight: 1,
                            fillColor: '#ECEFF1',
                            fillOpacity: 0.5
                        }}
                    />
                </>
            )}
        </MapContainer>
    );
};

export default WorldMap;
